import { getQueryClient } from '@/lib/query/client/query-client';
import { useMutation } from '@tanstack/react-query';

import { storageLocationsApi } from './storage-locations.api';
import { storageLocationKeys } from './storage-locations.queries';
import type {
  CreateStorageLocationRequest,
  UpdateStorageLocationRequest
} from '../types';

export const useCreateStorageLocation = () => {
  return useMutation({
    mutationFn: (data: CreateStorageLocationRequest) =>
      storageLocationsApi.create(data),
    meta: {
      operationType: 'create',
      fallbackSuccessMessage: 'storageLocations.createSuccess'
    },
    onSuccess: () => {
      getQueryClient().invalidateQueries({
        queryKey: storageLocationKeys.lists()
      });
      getQueryClient().invalidateQueries({
        queryKey: storageLocationKeys.stats()
      });
    }
  });
};

export const useUpdateStorageLocation = () => {
  return useMutation({
    mutationFn: ({
      id,
      data
    }: {
      id: number;
      data: UpdateStorageLocationRequest;
    }) => storageLocationsApi.update(id, data),
    meta: {
      operationType: 'update',
      fallbackSuccessMessage: 'storageLocations.updateSuccess'
    },
    onSuccess: () => {
      getQueryClient().invalidateQueries({
        queryKey: storageLocationKeys.lists()
      });
    }
  });
};

export const useDeleteStorageLocation = () => {
  return useMutation({
    mutationFn: ({ id, force }: { id: number; force?: boolean }) =>
      storageLocationsApi.delete(id, force),
    meta: {
      operationType: 'delete',
      fallbackSuccessMessage: 'storageLocations.deleteSuccess'
    },
    onSuccess: () => {
      getQueryClient().invalidateQueries({
        queryKey: storageLocationKeys.lists()
      });
      getQueryClient().invalidateQueries({
        queryKey: storageLocationKeys.stats()
      });
    }
  });
};
